module.exports = __webpack_public_path__ + "static/media/bg1.9492efec.jpg";